import { Modal, Typography } from 'antd';
import React from 'react';

import { useDeleteFolder } from '@/api';
import { showMessage } from '@/shared/utils';

interface DeleteFolderModalProps {
  isOpen: boolean;
  onCancel: () => void;
  onSuccess: () => void;
  folderPath: string | undefined;
}

export function DeleteFolderModal({
  isOpen,
  onCancel,
  onSuccess,
  folderPath,
}: DeleteFolderModalProps) {
  const deleteFolderMutation = useDeleteFolder();

  const handleOk = () => {
    if (!folderPath) {
      return;
    }
    deleteFolderMutation.mutate(folderPath, {
      onSuccess: () => {
        showMessage('success', 'Ordner erfolgreich gelöscht');
        onSuccess();
      },
      onError: (error) => {
        showMessage('error', error.message);
      },
    });
  };

  return (
    <Modal title='Ordner löschen' open={isOpen} onOk={handleOk} onCancel={onCancel}>
      <Typography.Text>
        Möchten Sie den Ordner "{folderPath?.replace(/\/+$/, '').split('/').pop()}" und alle Inhalte
        wirklich löschen?
      </Typography.Text>
    </Modal>
  );
}
